import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorCount: 0 };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
    // Auto-recover after 2 seconds (max 3 retries to prevent infinite loop)
    this.setState(prev => {
      const newCount = prev.errorCount + 1;
      if (newCount <= 3) {
        setTimeout(() => this.setState({ hasError: false }), 2000);
      }
      return { errorCount: newCount };
    });
  }

  render() {
    if (this.state.hasError && this.state.errorCount > 3) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#020617', color: '#f8fafc', fontFamily: 'Inter, sans-serif', flexDirection: 'column', gap: '16px'
        }}>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold' }}>Something went wrong</h1>
          <p style={{ color: '#94a3b8' }}>Please refresh the page or try again later.</p>
          <button
            onClick={() => { this.setState({ hasError: false, errorCount: 0 }); window.location.href = '/'; }}
            style={{
              padding: '12px 24px', background: '#4f46e5', color: 'white', border: 'none',
              borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600'
            }}
          >
            Go to Homepage
          </button>
        </div>
      );
    }
    if (this.state.hasError) {
      // Show loading while auto-recovering
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#020617', color: '#f8fafc'
        }}>
          <div style={{ width: '32px', height: '32px', border: '3px solid #334155', borderTop: '3px solid #6366f1', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
